/** Verified drop allowance — dispatch payroll engine */
export const FLAT_TRIP_ALLOWANCE_AED = 75;

/** UAE contract baseline: hourly OT = (basic ÷ 200) × 1.5 */
export const OT_HOURS_DIVISOR = 200;
export const OT_MULTIPLIER = 1.5;

/**
 * @typedef {Object} PayrollDriverRecord
 * @property {string} id
 * @property {string} name
 * @property {number} baseSalary
 * @property {number} tripsCompleted
 * @property {number} otHours
 * @property {number} penalties
 */

/**
 * @typedef {Object} DriverPayrollLedger
 * @property {string} id
 * @property {string} name
 * @property {number} baseSalary
 * @property {number} tripsCompleted
 * @property {number} otHours
 * @property {number} penalties
 * @property {number} tripIncentives
 * @property {number} overtimeRate
 * @property {number} overtimePay
 * @property {number} netPayout
 */

export function calcHourlyOvertimeRate(baseSalary) {
  const basic = Number(baseSalary) || 0;
  return Math.round((basic / OT_HOURS_DIVISOR) * OT_MULTIPLIER * 100) / 100;
}

/**
 * Pure calculation engine — re-runs instantly when driver record fields change.
 * @param {PayrollDriverRecord} record
 * @returns {DriverPayrollLedger}
 */
export function computeDriverLedger(record) {
  if (!record) return null;

  const baseSalary = Number(record.baseSalary) || 0;
  const tripsCompleted = Number(record.tripsCompleted) || 0;
  const otHours = Number(record.otHours) || 0;
  const penalties = Number(record.penalties) || 0;

  const tripIncentives = tripsCompleted * FLAT_TRIP_ALLOWANCE_AED;
  const overtimeRate = calcHourlyOvertimeRate(baseSalary);
  const overtimePay = Math.round(otHours * overtimeRate);
  const netPayout = baseSalary + tripIncentives + overtimePay - penalties;

  return {
    id: record.id,
    name: record.name,
    baseSalary,
    tripsCompleted,
    otHours,
    penalties,
    tripIncentives,
    overtimeRate,
    overtimePay,
    netPayout,
  };
}
